import React from 'react';

function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center" style={{ backgroundColor: '#0F1E3C' }} data-testid="loading-screen">
      <img
        src="/icons/splash-icon.png"
        alt="Helm Core"
        className="w-28 h-28 object-contain animate-fade-in"
      />
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in { animation: fadeIn 0.6s ease-out forwards; }
      `}</style>
    </div>
  );
}

export default LoadingScreen;
